<script lang="ts">
	import lazyload from '../helpers/lazyload';
	export let minHeight = 0;
</script>

<div
	style="min-height:{minHeight}px"
	id={Math.floor(Math.random() * 10e8).toString()}
	use:lazyload
	on:load
>
	<slot />
</div>
